<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear nuevo usuario</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group mb-2">
                                <small class="input-title">Tipo de cuenta</small>
                                <v-select v-model="data.account_type"
                                    :items="accounts"
                                    hide-details
                                    class="form-control form-control-sm"
                                    @change="CHANGE"
                                    :class="errors.account_type ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.account_type" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-2" v-if="data.account_type == 2">
                                <small class="input-title">Nombre de la Empresa</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.company" :class="errors.company ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.company" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Tipo de Identificación</small>
                                <v-select v-model="data.identification_type"
                                    :items="identifications.filter((e) => data.account_type == 2 ? e.value == 2 : e.value != 2)"
                                    hide-details
                                    class="form-control form-control-sm"
                                    :class="errors.identification_type ? 'is-invalid' : ''">
                                </v-select>
                                <small class="invalid-feedback" v-for="(error, index) in errors.identification_type" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">{{ data.account_type == 2 ? 'Cédula Jurídica' : 'Identificación' }}</small>
                                <input type="text" class="form-control form-control-sm" v-mask="format" v-model="data.identification" :class="errors.identification ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.identification" :key="index">{{ error }}</small>
                                <small v-if="data.account_type == 2">Ejemplo: Si es 3-101-123456 se debe digitar 3101123456</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2" v-if="data.account_type != 2">
                                <small class="input-title">Nombre</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.first_name" :class="errors.first_name ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.first_name" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2" v-if="data.account_type != 2">
                                <small class="input-title">Apellido</small>
                                <input type="text" class="form-control form-control-sm" v-model="data.last_name" :class="errors.last_name ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.last_name" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2" v-if="$route.params.role == 'warehouses'">
                                <small class="input-title">Bodega</small>
                                <v-select v-model="data.warehouse_id" :items="warehouses" :item-text="(item) => item.code + '-' + item.name" item-value="id"
                                    hide-details no-data class="form-control form-control-sm"
                                    :class="errors.warehouse_id ? 'is-invalid' : ''">
                                </v-select>  
                                <small class="invalid-feedback" v-for="(error, index) in errors.warehouse_id" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Correo Electrónico</small>
                                <input type="email" class="form-control form-control-sm" v-model="data.email" :class="errors.email ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.email" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Descuento: </small>
                                <div class="input-group input-group-sm">
                                    <input type="text" class="form-control form-control-sm" v-model="data.discount" @keypress="DOUBLE" :class="errors.discount ? 'is-invalid' : ''">
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            %
                                        </span>
                                    </div>
                                    <small class="invalid-feedback" v-for="(error, index) in errors.discount" :key="index">{{ error }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group mb-2">
                                <small class="input-title">Precio por libra: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.price_per_pound" @keypress="DOUBLE" :class="errors.price_per_pound ? 'is-invalid' : ''" placeholder="0">
                                <small class="invalid-feedback" v-for="(error, index) in errors.price_per_pound" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-lg-6" v-if="data.price_per_pound > 0">
                            <div class="form-group mb-2">
                                <small class="input-title">Monto minimo facturable: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.minimum_billable_amount" @keypress="DOUBLE" :class="errors.minimum_billable_amount ? 'is-invalid' : ''" placeholder="0">
                                <small class="invalid-feedback" v-for="(error, index) in errors.minimum_billable_amount" :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: ['oncreate'],
    data() {
        return {
            type: false,
            data: {
                account_type: 1,
                identification_type: 1,
            },
            identifications: [
                { value: 1, text: 'Cédula Nacional' },
                { value: 2, text: 'Cédula Juridica' },
                { value: 3, text: 'Cédula de Residencia (DIMEX)' },
                { value: 4, text: 'Pasaporte' },
            ],
            errors: {},
            count: 0,
            warehouses: [],
        }
    },
    computed: {
        ...mapGetters([
            'accounts',
        ]),
        format: function(){
            let format = ''
            if(this.data.identification_type == 1){
                format = '0#-####-####'
            } else if(this.data.identification_type == 2){
                format = '3-###-######'
            } else if(this.data.identification_type == 3){
                format = '1############'
            } else {
                format = '9#################'
            }
            return format
        }
    },
    created(){
        let vue = this
        vue.WAREHOUSES()
        vue.data.account_type = vue.$route.params.role != 'customers' ? 0 : 1
    },
    methods: {
        CHANGE: function () {
            let data = this.identifications.filter((e) => this.data.account_type == 2 ? e.value == 2 : e.value != 2)
            this.data.identification_type = data.findIndex((e) => e.value == this.data.identification_type) != -1 ? this.data.identification_type : data[0].value
        },
        WAREHOUSES: function(){
            let vue = this
            axios({url: 'all/warehouses', method: 'GET' })
            .then((resp) => {
                vue.warehouses = resp.data
            })
        },
        CREATE: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                vue.data.role = vue.$route.params.role
                if(vue.data.account_type == 2){
                    vue.data.identification_type = 2
                }
                axios({ url: '/users', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.data = {}
                    })
                    .catch((err) => {
                        if (err.response.status === 422) {
                            vue.errors = err.response.data
                        } else if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/users/Create.vue